import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { TypeAnimation } from 'react-type-animation';
import Particles from 'react-tsparticles';
import { loadSlim } from 'tsparticles-slim';
import logo from '../assets/Masriq_Logo.png'; // Ensure this path is correct

const Loader = () => {
  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setShowLoader(false), 5000);
    return () => clearTimeout(timer);
  }, []);

  // Optional: Play startup chime
  useEffect(() => {
    const playAudioOnUserAction = () => {
      const audio = new Audio('/sounds/startup.mp3');
      audio.volume = 0.4;
      audio.play();

      // Clean up: only play once
      window.removeEventListener('click', playAudioOnUserAction);
      window.removeEventListener('touchstart', playAudioOnUserAction);
      window.removeEventListener('keydown', playAudioOnUserAction);
    };

    // Listen for first user interaction
    window.addEventListener('click', playAudioOnUserAction);
    window.addEventListener('touchstart', playAudioOnUserAction);
    window.addEventListener('keydown', playAudioOnUserAction);

    return () => {
      window.removeEventListener('click', playAudioOnUserAction);
      window.removeEventListener('touchstart', playAudioOnUserAction);
      window.removeEventListener('keydown', playAudioOnUserAction);
    };
  }, []);

  const particlesInit = async (main) => {
    await loadSlim(main);
  };

  return (
    <AnimatePresence>
      {showLoader && (
        <motion.div
          className="fixed inset-0 z-[9999] bg-[#0B0C1C] flex flex-col items-center justify-center gap-8"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.8 }}
        >
          {/* Animated Background Circuit Particles */}
          <Particles
            id="tsparticles"
            init={particlesInit}
            options={{
              fullScreen: { enable: false },
              background: { color: '#0B0C1C' },
              particles: {
                number: { value: 60 },
                color: { value: '#00ffff' },
                links: {
                  enable: true,
                  color: '#00ffff',
                  distance: 100,
                  opacity: 0.2,
                },
                move: {
                  enable: true,
                  speed: 1.2,
                  outModes: 'bounce',
                },
                size: { value: { min: 1, max: 3 } },
              },
              detectRetina: true,
            }}
            className="absolute inset-0 z-0"
          />

          {/* Logo Animation */}
          <motion.img
            src={logo}
            alt="MASRIQ Logo"
            className="w-32 h-32 object-contain z-10"
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{
              opacity: 1,
              scale: [1, 1.05, 1],
              rotate: [0, 2, -2, 0],
            }}
            transition={{
              duration: 2,
              repeat: Infinity,
              repeatType: 'reverse',
              ease: 'easeInOut',
            }}
          />

          {/* Typing Text */}
          <TypeAnimation
            sequence={[
              'Launching MASRIQ...',
              1500,
              'Empowering Intelligence...',
              1500,
              'Reshaping the Future...',
              1200,
            ]}
            wrapper="span"
            speed={55}
            className="text-white text-lg sm:text-xl tracking-wide z-10"
            repeat={Infinity}
          />
          <p className="text-white/50 text-sm mt-2 italic tracking-wide z-10">
            Tap anywhere to activate sound experience 🎧
          </p>


          {/* Glowing Progress Bar */}
          <div className="w-64 h-2 bg-white/10 rounded-full overflow-hidden z-10">
            <motion.div
              className="h-full bg-gradient-to-r from-cyan-400 via-purple-500 to-blue-500"
              animate={{ x: ['-100%', '100%'] }}
              transition={{
                repeat: Infinity,
                duration: 2,
                ease: 'easeInOut',
              }}
              style={{ width: '50%' }}
            />
          </div>

        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Loader;
